<div id="outer">
    <ul class="nav nav-tabs p-2">
        @for (form of Forms | orderBy: "Order"; track form) {
            <li [ngClass]="GetClass(form)" style="cursor: pointer" role="presentation">
                <a (click)="LoadForm(form, $event)"><span [innerText]="form.FormName"></span></a>
            </li>
        }
    </ul>
    <iframe style="width: 100%" id="iframeDiv"></iframe>
</div>
